import { useContext } from 'react';
import { atom, SetterOrUpdater, useRecoilState } from 'recoil';
import { SelectionGroupValue } from 'fronton-react/selection-group/types';
import { DataContext } from 'entries/common/widgets/context';
import { useSurfaces } from '../../hooks/use-surfaces';

export type TMaterialFormState = {
  [key: string]: {
    name: string;
    value: SelectionGroupValue;
  };
};

type TMaterialState = {
  materialFormState: TMaterialFormState;
  setMaterial: SetterOrUpdater<TMaterialFormState>;
};

const materialState = atom({
  key: 'material',
  default: {},
});

export const useMaterialState = (): TMaterialState => {
  const data = useContext(DataContext);
  const surface = useSurfaces();

  const initialSurface = surface[0];

  const hasMaterialsInDefaultSurface = initialSurface.materials.length !== 0;

  const defaultState =
    data?.isSurfaceOne && hasMaterialsInDefaultSurface
      ? {
          [initialSurface.name]: { name: initialSurface.label, value: initialSurface.materials[0].label },
        }
      : {};

  const [materialFormState, setMaterial] = useRecoilState<TMaterialFormState>(materialState);

  if (!Object.keys(materialFormState).length && data?.isSurfaceOne && hasMaterialsInDefaultSurface) {
    setMaterial(defaultState);
  }

  return {
    materialFormState,
    setMaterial,
  };
};
